module.exports = __webpack_public_path__ + "img/dj.60b7a235.png";